/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { startsWith } from 'lodash'

const CSV_FORMULA_CHARS = ['=', '+', '-', '@']

const cellHasFormulas = (val: string) =>
  CSV_FORMULA_CHARS.some((formulaChar) => startsWith(val, formulaChar))

export const sanitizeCsvField = (value: string) => {
  // Remove all tab characters
  let sanitizeValue = value.replace(/\t/g, '')

  // Dangerous starting characters
  if (cellHasFormulas(sanitizeValue)) {
    sanitizeValue = "'" + sanitizeValue // Prepend single quote
  }

  return sanitizeValue
}
